// GTM配置
export const setGtmDataLayer = (dataLayer) => {
  if (typeof window !== "undefined") {
    // 初始化 dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayer);
  }
}
